import RoleDetailsDrawer from './RoleDetailsDrawer.vue';
import UserDetailsDrawer from './UserDetailsDrawer.vue';

export default {
	RoleDetailsDrawer,
	UserDetailsDrawer,
};
